(() => {
  const reviewSectionSelector = '[id$="__1732993270e6ee7ecc"]';

  function findReviewSection() {
    const knownSection = document.querySelector(reviewSectionSelector);
    if (knownSection) return knownSection;

    const yotpoCarousel = document.querySelector(
      '.yotpo-reviews-carousel, [class*="yotpo-reviews-carousel"], [data-yotpo-element-id]'
    );
    return yotpoCarousel ? yotpoCarousel.closest('.shopify-section') : null;
  }

  function replaceReviewCount(section) {
    if (!section) return;

    const walker = document.createTreeWalker(section, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      const original = node.nodeValue;
      const replacement = original
        .replace(/197\s*reviews/gi, '500+ reviews')
        .replace(/^\s*197\s*$/g, original.replace('197', '500+'));

      if (replacement !== original) node.nodeValue = replacement;
    });
  }

  function refreshReviews() {
    const section = findReviewSection();
    if (!section) return;
    replaceReviewCount(section);
  }

  function enhancePlantFaqs() {
    document.querySelectorAll('.meraya-plant-profile__faq-content').forEach((container) => {
      if (container.dataset.accordionReady === 'true') return;

      const scope = container.querySelector(':scope > .metafield-rich_text_field') || container;
      const headings = Array.from(scope.children).filter((child) => child.tagName === 'H3');
      headings.forEach((heading, index) => {
        const details = document.createElement('details');
        const summary = document.createElement('summary');
        const answer = document.createElement('div');
        answer.className = 'meraya-plant-profile__faq-answer';
        summary.textContent = heading.textContent;
        if (index === 0) details.open = true;

        let sibling = heading.nextElementSibling;
        while (sibling && sibling.tagName !== 'H3') {
          const next = sibling.nextElementSibling;
          answer.appendChild(sibling);
          sibling = next;
        }

        details.append(summary, answer);
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          scope.querySelectorAll(':scope > details[open]').forEach((item) => {
            if (item !== details) item.open = false;
          });
        });
        heading.replaceWith(details);
      });

      container.dataset.accordionReady = 'true';
    });
  }

  function initializePlantScrollspy() {
    const navigation = document.querySelector('.meraya-plant-profile__tabs');
    if (!navigation || navigation.dataset.scrollspyReady === 'true') return;

    const links = Array.from(navigation.querySelectorAll('a[href^="#"]'));
    const sections = links
      .map((link) => ({ link, section: document.querySelector(link.getAttribute('href')) }))
      .filter((item) => item.section);
    if (!sections.length) return;

    let ticking = false;
    const updateActiveSection = () => {
      const marker = window.scrollY + Math.max(180, window.innerHeight * 0.34);
      let current = sections[0];

      sections.forEach((item) => {
        const sectionTop = item.section.getBoundingClientRect().top + window.scrollY;
        if (sectionTop <= marker) current = item;
      });

      links.forEach((link) => {
        const active = link === current.link;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateActiveSection);
    };

    links.forEach((link) => {
      link.addEventListener('click', () => {
        links.forEach((item) => item.classList.toggle('is-active', item === link));
      });
    });
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    navigation.dataset.scrollspyReady = 'true';
    updateActiveSection();
  }

  function initializeEnhancements() {
    refreshReviews();
    enhancePlantFaqs();
    initializePlantScrollspy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeEnhancements, { once: true });
  } else {
    initializeEnhancements();
  }

  [500, 1200, 2500, 5000].forEach((delay) => window.setTimeout(refreshReviews, delay));
})();
